export default __webpack_public_path__ + "static/media/img-0335-botswana-premium-face.47895e1a.png";